import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";

import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { LayoutModule } from '@angular/cdk/layout';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppidService } from "./base/services/appid/appid.service";

import { GigmonsterModule } from "./gigmonster/gigmonster.module";
import { EasysuiteModule } from "./easysuite/easysuite.module";
import { GlobalSharedModule } from "./global-shared/global-shared.module";

//The below function calls the getAppID() in the appidService file when the application is loaded first and sets the appID. So its available to any service that access the appID.

// this approach is to overcome the asynchronous nature of the code.
function initializeAppID(appidService: AppidService) {
  return () => appidService.getAppID();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    LayoutModule,
    FlexLayoutModule,
    GigmonsterModule,
    EasysuiteModule,
    GlobalSharedModule
  ],
  providers: [
    AppidService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppID,
      deps: [AppidService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: true,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
